import translationsData from '@/locales/lang.json'

const langCodes = ['en', 'de', 'es', 'pt', 'fr', 'it', 'tr', 'ja', 'pl', 'ar']

export function getTranslation(phrase, lang = 'r') {
    if (!langCodes.includes(lang) && lang !== 'ru') {
        lang = 'en'
    }
    if (lang === 'ru') {
        return phrase
    } else {
        if (translationsData[phrase]) {
            return translationsData[phrase][langCodes.indexOf(lang)] || phrase
        } else {
            return phrase
        }
    }
}
